import z from 'zod'

import { NoteFormData } from './reservation-details.types'

export const ReservationDetailsTabsEnum = z.enum([
  'details',
  'payments',
  'custom-questions',
  'documents',
  'notes',
])

export type ReservationDetailsTab = z.infer<typeof ReservationDetailsTabsEnum>

export const reservationDetailsQueryParamsSchema = z.object({
  tab: ReservationDetailsTabsEnum,
})

export const reservationDetailsQueryParams: z.infer<typeof reservationDetailsQueryParamsSchema> = {
  tab: ReservationDetailsTabsEnum.enum.details,
}

export const reservationEmptyNoteFormValues: NoteFormData = {
  noteBody: '',
  title: '',
}
